export const ContainerCardsSymbology = ({
	data = [],
	extraClass = "",
	labelName = "",
	labelBold = false,
	title = "",
	conditionalFilter = null,
	customProp = null,
	childWith = "w-16",
}) => {
	return (
		<div className={`w-full flex flex-col gap-4 p-4 border-2 border-[#EFF2F5] rounded-md ${extraClass}`}>
			<h4 className="text-xs font-bold mb-4">{title}</h4>
			<div className="flex justify-center items-start flex-wrap gap-4">
				{data.map((child, index) => {
					let color = child.color ? child.color : "#ccc";

					if (conditionalFilter && conditionalFilter(child[customProp])) {
						return null;
					}

					return (
						<div key={`${index}-categories`} className="flex flex-wrap justify-center h-max">
							<div className={`flex flex-col h-full justify-center items-center gap-2 ${childWith}`}>
								<div className="w-3 h-3 rounded-full" style={{ backgroundColor: color }} />
								<span className="font-bold text-xs">{child.hourRange}</span>
								<span className={`text-[12px] text-center ${labelBold ? "font-bold" : ""}`}>{child[labelName]}</span>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};
